require('jquery.maskedinput/src/jquery.maskedinput.js');
export default () => {

  $('.file__input').on('change', function () {
    if ($(this).val().lastIndexOf('\\')) {
      var n = $(this).val().lastIndexOf('\\') + 1;
    } else {
      var n = $(this).val().lastIndexOf('/') + 1;
    }
    var fileName = $(this).val().slice(n);
    if (fileName === '') {
      const textDefault = $(this).parents('.file').find('.file__text').attr('data-text')
      $(this).parents('.file').find('.file__text').text(textDefault);
    } else {
      $(this).parents('.file').find('.file__text').text(fileName);
    }
  });

  let header = document.querySelector('.header')
  let searchBtn = document.querySelector('.header__btn--search')
  let marginTop = $(window).width() > 1200 ? 100 : 74

  if (document.querySelector('.js-header-transparent')) {
    window.scrollY < 50 ? header.classList.add('header--transparent') : ''
    window.addEventListener('scroll', () => {
      window.scrollY > 50 ? header.classList.remove('header--transparent') : header.classList.add('header--transparent')
    })
  }

  searchBtn.addEventListener('click', function (event) {
    event.stopPropagation()
    header.classList.toggle('header--search')
  })

  document.addEventListener('click', function (event) {
    event.stopPropagation()
    if ($(event.target).closest(".header__search").length) return;
    header.classList.remove('header--search')
  })

  jQuery(function ($) {
    $("input[type=tel]").mask("+38 (099) - 999 - 99 - 99", { autoclear: false });
  });

  $('.header__mobile-btn').on('click', () => {
    $('.header__mobile').addClass('active')
    setTimeout(() => {
      $('.header__mobile-box').addClass('active')
    }, 300);
  })

  $('.js-close-mobile').on('click', () => {
    $('.header__mobile-box').removeClass('active')
    setTimeout(() => {
      $('.header__mobile').removeClass('active')
    }, 300);
  })

  $('.tab-options__item.has_description').each(function () {
    $(this).on('click', function () {
      if ($(this).find('.option__description').length > 0) {
        const text = $(this).find('.option__description').html();
        $('.popup-options-text').html('');
        $('.popup-options-text').html(text);
        $('.popup--options').addClass('active')
      }
    })
  })

  $('.js-call-back').on('click', () => {
    $('.popup--callback').addClass('active')
  })

  $('.js-price').on('click', () => {
    $('.popup--price').addClass('active')
  })

  $('.js-vacancy').on('click', () => {
    $('.popup--callback').addClass('active')
  })

  $('.js-registration').on('click', () => {
    $('.popup').removeClass('active')
    $('.popup--registration').addClass('active')
  })

  $('.js-login').on('click', () => {
    $('.popup').removeClass('active')
    $('.popup--authorization').addClass('active')
  })

  $('.js-password').on('click', () => {
    $('.popup').removeClass('active')
    $('.popup--password').addClass('active')
  })

  $('.js-close-popup').on('click', () => {
    $('.popup').removeClass('active')
  })

  if (document.querySelector('.news-one__right')) document.querySelector('.wrapper').classList.add('wrapper--sticky')

  $('.vacancy__item-head').on('click', function () {
    if (!$(this).parents('.vacancy__item').hasClass('active')) {
      $('.vacancy__item').removeClass('active');
      $('.vacancy__item-body').slideUp();
    }
    $(this).parents('.vacancy__item').toggleClass('active');
    $(this).next('.vacancy__item-body').slideToggle('active');
    setTimeout(() => {
      $('html, body').animate({
        scrollTop: $(this).parents('.vacancy__item').offset().top - marginTop
      }, 1000);
    }, 500);
  });

  $('.js-characteristics').on("click", function () {
    $('a[href="#tab1"]').click(function () {
      this.click();
    }).click();
    $('html, body').animate({
      scrollTop: $('.product__tabs-list').offset().top - marginTop
    }, 500);
    return false;
  })

  $('.js-details').on("click", function () {
    $('a[href="#tab2"]').click(function () {
      this.click();
    }).click();
    $('html, body').animate({
      scrollTop: $('.product__tabs-list').offset().top - marginTop
    }, 500);
    return false;
  })

  let fileInput = document.querySelectorAll('.files__input')
  let closeIcon = '<svg class="files__input-remove" width="9" height="9" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M0.264225 1.39922C-0.0715822 1.06341 -0.0897303 0.53711 0.22369 0.22369C0.53711 -0.0897305 1.06341 -0.0715821 1.39922 0.264225L11.7358 10.6008C12.0716 10.9366 12.0897 11.4629 11.7763 11.7763C11.4629 12.0897 10.9366 12.0716 10.6008 11.7358L0.264225 1.39922Z" /><path d="M1.78431 11.4318C1.47089 11.7452 0.944585 11.727 0.608777 11.3912C0.27297 11.0554 0.254822 10.5291 0.568242 10.2157L10.2157 0.568241C10.5291 0.254821 11.0554 0.272969 11.3912 0.608777C11.727 0.944584 11.7452 1.47089 11.4318 1.78431L1.78431 11.4318Z" /></svg >'
  fileInput.forEach(el => {
    let filesList = el.closest('.files').querySelector('.files__list')
    el.addEventListener('change', () => {
      if (el.files.length) {
        for (let i = 0; i < el.files.length; i++) {
          filesList.insertAdjacentHTML('beforeend', `<div class="files__item">${el.files[i].name + closeIcon}</div>`)
        }
      } else {
        filesList.innerHTML = ''
        console.log('no');
      }
      console.log(fileInput);
    })
  })

}


// WEBPACK FOOTER //
// app/scripts/components/custom.js